import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

const UnsavedChangesDialog = ({ handleContinue, handleKeepEditing, isOpen }) => (
  <Dialog
    maxWidth="xs"
    onClose={event => {
      event.stopPropagation();
      handleKeepEditing();
    }}
    open={isOpen}
    slotProps={{
      paper: { elevation: 10 },
    }}
    sx={{ '& .MuiDialog-paper': { height: 180, width: 330 } }}
  >
    <DialogTitle>Unsaved Changes</DialogTitle>
    <DialogContent>
      Are you sure you want to leave this page? You have unsaved changes.
    </DialogContent>
    <DialogActions sx={{ pb: 2, px: 2 }}>
      <Button autoFocus onClick={handleContinue} variant="outlined">
        Continue
      </Button>
      <Button onClick={handleKeepEditing}>Keep Editing</Button>
    </DialogActions>
  </Dialog>
);

UnsavedChangesDialog.propTypes = {
  handleContinue: PropTypes.func.isRequired,
  handleKeepEditing: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
};

export default UnsavedChangesDialog;
